import classNames from 'clsx'

import S from './HeroStatsBand.module.scss'

export interface HeroStatsBandItem {
  value: string
  captionLines: string[]
}

export type HeroStatsBandVariant = 'home' | 'forClubs' | 'fans'

interface HeroStatsBandProps {
  items: HeroStatsBandItem[]
  variant: HeroStatsBandVariant
}

function HeroStatsBand({ items, variant }: HeroStatsBandProps) {
  function renderTrack(trackId: 'a' | 'b') {
    return (
      <div
        className={S.marqueeTrack}
        aria-hidden={trackId === 'b' ? true : undefined}
      >
        {items.map(({ value, captionLines }) => (
          <div
            key={`${trackId}-${value}-${captionLines.join('-')}`}
            className={S.bandItem}
          >
            <div className={S.bandStat}>{value}</div>
            <div className={S.bandCaption}>
              {captionLines.map(line => (
                <span key={line} className={S.bandCaptionLine}>
                  {line}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div
      className={classNames(
        S.belowCtasBand,
        variant === 'home' && S.belowCtasBandHome,
        variant === 'forClubs' && S.belowCtasBandForClubs,
        variant === 'fans' && S.belowCtasBandFans
      )}
    >
      <div className={S.marqueeViewport}>
        <div className={S.marqueeGroup}>
          {renderTrack('a')}
          {renderTrack('b')}
        </div>
      </div>
    </div>
  )
}

export default HeroStatsBand
